module.exports = __webpack_public_path__ + "img/main.b2547394.svg";